// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"01847b70","258":"3a4909f3","585":"a8e712a4","686":"b6bca611","787":"d505bdf2"}[chunkId] + ".chunk.js";
};